import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import {formatDate} from "../../utils/formatDate";
import ModalStore from '../../stores/modals.store'

export default observer(({ store }) => {
  const visibleHistory = store.workspace.map((item) => item.id)

  useEffect(() => {
  }, [])
  
  return (
      <ViewerHistory>
        {store.history &&
        store.history.map((historyItem, index) => (
            <Option
                onClick={(_) =>
                    store.pushFromHistory(historyItem._id, historyItem.resultDate)
                }
                id={historyItem._id}
                selected={visibleHistory.includes(historyItem._id)}
				active={store.selectedWindowId==historyItem._id}
                key={historyItem.resultDate + historyItem._id}				
            >
              {formatDate(historyItem.resultDate)}
			  {historyItem.quiz ? <div style={{position: 'relative'}}><div 
				onClick={()=>{
					ModalStore.openModal("InfoModal", {
						title: "Анкета",
						text: <>
							{historyItem.quiz.rtype? <PP>{historyItem.quiz.rtype}</PP> : undefined}
							{historyItem.quiz.regularity=='first' ? <PP>Исследование впервые</PP> : undefined}
							{historyItem.quiz.regularity=='re' ? <PP>Исследование повторно</PP> : undefined}
							{historyItem.quiz.afterUltrasound || historyItem.quiz.afterMammography ? <PP>
								Ранее выполнялось: {historyItem.quiz.afterUltrasound ? 'УЗИ ' : undefined}
								{historyItem.quiz.afterMammography ? ' Маммография' : undefined}
							</PP>: undefined}
							{historyItem.quiz.registered && historyItem.quiz.registered!='' ? <PP>
								Состоит на учете по заболеванию м/ж: 
								{historyItem.quiz.registered=='yes' ? 'да ' : ''}
								{historyItem.quiz.registered=='no' ? 'нет ' : ''}
								{historyItem.quiz.registeredAdenomatoz ? 'Фиброаденоматоз ' : ''}
								{historyItem.quiz.registeredAdenoma ? 'Фиброаденома ' : ''}
								{historyItem.quiz.registeredCist ? 'Киста ' : ''}
								{historyItem.quiz.registeredTumor ? 'Опухоль ' : ''}
								{historyItem.quiz.registeredMastit ? 'Мастит ' : ''}
							</PP> : undefined}
							{historyItem.quiz.operations && historyItem.quiz.operations!='' ? <PP>
								Были ли операции на м/ж: 
								{historyItem.quiz.operations=='yes' ? 'да ' : ''}
								{historyItem.quiz.operations=='no' ? 'нет ' : ''}
								{historyItem.quiz.operationsRight ? 'На правой год ' + historyItem.quiz.operationsRightYear +
									' диагноз ' + historyItem.quiz.operationsRightDiagnisis: ''}
								{historyItem.quiz.operationsLeft ? 'На левой год ' + historyItem.quiz.operationsLeftYear +
									' диагноз ' + historyItem.quiz.operationsLeftDiagnisis: ''}
							</PP> : undefined}
							{historyItem.quiz.periodsNow && historyItem.quiz.periodsNow!='' ? <PP>
								В настоящее время: 
								{historyItem.quiz.periodsNow=='yes' ? 'Меструации есть ' : ''}
								{historyItem.quiz.periodsNow=='no' ? 'Менструаций нет ' : ''}
								{historyItem.quiz.periodsNow=='broke' ? 'Нарушение цикла ' : ''}
								{historyItem.quiz.periodsNow=='climax' ? 'Климакс ' : ''}
								{historyItem.quiz.periodsNow=='menopause' ? 'Менопауза ' : ''}
							</PP> : undefined}
							{historyItem.quiz.complaints && historyItem.quiz.complaints!='' ? <PP>
								Есть ли жалобы со стороны молочных желез: 
								{historyItem.quiz.complaints=='yes' ? 'да ' : ''}
								{historyItem.quiz.complaints=='no' ? 'нет ' : ''}
								{historyItem.quiz.complaintsRight ? 'На правой ' : ''}
								{historyItem.quiz.complaintsLeft ? 'На левой ' : ''}
								{historyItem.quiz.complaintsCharacterPain ? 'Боль ' : ''}
								{historyItem.quiz.complaintsCharacterDiscomfort ? 'Неприятные ощущения ' : ''}
								{historyItem.quiz.complaintsCharacterDischarge ? 'Выделения из соска ' : ''}
								{historyItem.quiz.complaintsCharacterSeals ? 'Прощупывается уплотнения ' : ''}
								{historyItem.quiz.complaintsCharacterPeriod ? 'Боль связана с месячными ' : ''}
								{historyItem.quiz.complaintsCharacterUnperiod ? 'Боль не связана с месячными ' : ''}
							</PP> : undefined}
							{historyItem.quiz.lastPeriods && historyItem.quiz.lastPeriods!='' ? <PP>
								Если есть месячные, указать первый день последних месячных в текущем году:
								{historyItem.quiz.lastPeriods}
							</PP> : undefined}
							{historyItem.quiz.review && historyItem.quiz.review!='' ? <PP>
								Внешний осмотр:
								{historyItem.quiz.review}
							</PP> : undefined}
							{historyItem.quiz.prediagnos && historyItem.quiz.prediagnos!='' ? <PP>
								<b>Предварительный диагноз:</b>
								<PPX>{historyItem.quiz.prediagnos}</PPX>
							</PP> : undefined}
							{historyItem.quiz.sentby && historyItem.quiz.sentby!='' ? <PP>
								<b>Кто направил:</b>
								<PPX>{historyItem.quiz.sentby}</PPX>
							</PP> : undefined}
							{historyItem.quiz.anamnes && historyItem.quiz.anamnes!='' ? <PP>
								<b>Анамнез:</b>
								<PPX>{historyItem.quiz.anamnes}</PPX>
							</PP> : undefined}
						</>,
						close: ()=>{}
					})
				}}
				style={{position: 'absolute',right:0,top:12,backgroundColor: 'black', fontSize: 16,
					borderColor:'white',borderWidth:1,borderStyle:'solid',borderRadius:15,padding:3,}}
				>Анкета</div></div> : undefined}
            </Option>
        ))}
      </ViewerHistory>
  )
})


const PP = styled.div` 
	padding-top: 10px;
`

const PPX = styled.div` 
	white-space: pre-line;
`


const ViewerHistory = styled.div`
  position: absolute;
  right: 0;
  width: 149px;
  height: 100%;
  background: black;
  padding-top: 4px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0;
  }
`
const Option = styled.div`
  font-family: 'Open Sans', serif;
  font-size: 20px;
  color: white;
  width: 90%;
  height: 63px;
  border-radius: 20px;
  border: ${(p) => p.active ? '5px solid rgba(127, 196, 253, 1)' : p.selected && '5px solid rgba(200, 200, 200, 1)'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 auto;
  margin-bottom: 12px;
`
